import React from 'react';
import {
  BarChart,
  Bar,
  ResponsiveContainer,
  YAxis,
  XAxis,
  Cell,
  Tooltip,
} from 'recharts';

const CustomBarChart = ({ data, colors }) => {
  return (
    <div style={{ width: '100%', height: 250 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <YAxis
            ticks={[0, 10, 20, 30, 40, 50]}
            axisLine={false}
            tickLine={false}
            tick={{
              fontFamily: 'General Sans',
              fontWeight: 400,
              fontSize: 12,
              lineHeight: 18,
              letterSpacing: 0,
              textAnchor: 'middle',
            }}
          />
          <XAxis
            dataKey="name"
            interval={0}
            axisLine={false}
            tickLine={false}
            tick={{
              fontFamily: 'General Sans',
              fontWeight: 500,
              fontSize: 13,
              lineHeight: 20,
              letterSpacing: 0,
              textAnchor: 'middle',
            }}
          />
          
          {/* Add Tooltip for hover details */}
          <Tooltip
            cursor={{ fill: 'rgba(0,0,0,0.05)' }} // optional hover background
            formatter={(value, name) => [`${value}`, name]} // format the value
          />

          <Bar dataKey="number" radius={[15, 15, 15, 15]} barSize={80}>
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={colors[index % colors.length]}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CustomBarChart;